import { useState, useEffect } from 'react';
import { getDefectRiskRatings } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useRiskRatings = (showAll = true) => {
  const dispatch = useDispatch();
  const [riskRatings, setRiskRatings] = useState([]);

  useEffect(() => {
    const loadRiskRatings = async () => {
      try {
        const ratings = await getDefectRiskRatings();
        if (ratings?.status) {
          const fetchedRatings = ratings.data || [];
          // Conditionally add 'Show All' if risk ratings exist and showAll is true
          const updatedRatings = (showAll && fetchedRatings.length > 0)
            ? [SHOW_ALL_OPTION, ...fetchedRatings]
            : fetchedRatings;
          setRiskRatings(updatedRatings);
        }
      } catch (error) {
        dispatch(showError('Failed to load risk ratings'));
        setRiskRatings([]); // Reset on error
      }
    };
    loadRiskRatings();
  }, [showAll]);

  return riskRatings;
}; 
